import type { Locale } from '@xdocs/i18n';

/**
 * STOP-GAP local catalog for this page's chrome ONLY (the per-type toggle
 * grid itself reuses the already-shipped `settings:notifications.*` keys via
 * the reused `<NotificationsPrefsSection>` — nothing duplicated there). New
 * copy here: the page header, the "email cadence" placeholder (FEATURES.md
 * "Notifications preferences (part of F33/F23)": "Email cadence (instant vs
 * digest)" — no backing field exists yet, see this file's usage site for the
 * placeholder rationale), and the FTUE replay entry point (F9: "re-runnable
 * from Settings").
 *
 * OPEN ISSUE: fold into `packages/i18n/src/catalogs/{en,ro}/settings.json`
 * under a `notificationsSettings.*` namespace once that package is in scope.
 */
const en = {
  'page.title': 'Notification settings',
  'page.description': 'Choose how and when xDocs notifies you.',
  'cadence.title': 'Email cadence',
  'cadence.description': 'Get emails the moment something happens, or bundled into a daily summary.',
  'cadence.instant': 'Instant',
  'cadence.digest': 'Daily digest',
  'cadence.comingSoon': 'Coming soon — this will apply to your email notifications.',
  'replay.title': 'Replay the welcome tour',
  'replay.description': 'See the guided tour again, from the start.',
  'replay.action': 'Replay tutorial',
} as const;

const ro: Record<keyof typeof en, string> = {
  'page.title': 'Setări notificări',
  'page.description': 'Alege cum și când te anunță xDocs.',
  'cadence.title': 'Frecvența e-mailurilor',
  'cadence.description': 'Primește e-mailuri chiar în momentul evenimentului sau grupate într-un rezumat zilnic.',
  'cadence.instant': 'Instant',
  'cadence.digest': 'Rezumat zilnic',
  'cadence.comingSoon': 'În curând — se va aplica notificărilor tale pe e-mail.',
  'replay.title': 'Revezi turul de bun venit',
  'replay.description': 'Vezi din nou turul ghidat, de la început.',
  'replay.action': 'Reia tutorialul',
};

export const NOTIFICATIONS_SETTINGS_PAGE_CATALOG: Record<Locale, Record<keyof typeof en, string>> = { en, ro };

export type NotificationsSettingsPageCatalogKey = keyof typeof en;
